<template>
  <div class="outer-wrapper">
    <div class="editor-wrapper" v-show="!detailShow">
      <div class="title-wrapper">
        <span>标准</span>
      </div>
      <van-search placeholder="请输入搜索关键词" v-model="keyword" @search="onSearch" />
      <van-list
        v-model="itemTable.loading"
        :finished="itemTable.finished"
        finished-text="没有更多了"
        :error.sync="itemTable.error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-cell
          v-for="item in itemTable.tivdata"
          :key="item.id+'verify'"
          :title="item.standard_prefix+' '+item.standard_no+'-'+item.standard_year"
          :label="'《'+item.standard_name_ch+'》'"
          label-class="cell-label"
          @click="chooseItem(item)"
          is-link
          
        >
        <template>
          <van-tag plain type="success" v-if="item.if_controlled==='受控'" class="c-tag">受控</van-tag>
          <van-tag round :type="calStatCertificate(item.cma)" v-if="item.cma&&item.cma!=='未认证'" class="c-tag">CMA</van-tag>
          <van-tag round :type="calStatCertificate(item.cnas)" v-if="item.cnas&&item.cnas!=='未认证'" class="c-tag">CNAS</van-tag>
          <span :class="calStat(item.ifValid)">{{item.ifValid}}</span>
        </template>
        </van-cell>
      </van-list>
    </div>
    <div class="report-wrapper" v-show="detailShow">
      <van-nav-bar title="标准详情" left-text="返回" left-arrow @click-left="onClickBack" fixed></van-nav-bar>
      <p
        class="detail-title"
      >{{currentItem.standard_prefix+' '+currentItem.standard_no+'-'+currentItem.standard_year}}</p>
      <van-panel title="标准中文名称：" desc status>
        <div class="d-wrapper">
          <p>{{currentItem.standard_name_ch}}</p>
        </div>
      </van-panel>
      <van-panel title="标准英名称：" desc status>
        <div class="d-wrapper">
          <p>{{currentItem.standard_name_en}}</p>
        </div>
      </van-panel>
      <van-cell title="发布日期" :value="currentItem.standard_date" />
      <van-cell title="实施日期" :value="currentItem.standard_date_do" />
      <van-cell
        title="当前状态"
        :value="currentItem.ifValid"
        :value-class="calStat(currentItem.ifValid)"
      />
      <van-cell title="详情" value="点击下载标准" is-link @click="linkTo(currentItem.file_url)" />
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));

function itemTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
      /*{
                        standard_prefix:'',
                        standard_no:"",
                        standard_year:'',
                        standard_name_ch:'',
                        file_url:'',
                        nation:'',
                        ifValid:'',
                    }*/
    ]
  };
}

export default {
  name: "standardList",
  props: [],
  components: {},
  data() {
    return {
      askData: "standardList",
      itemTable: itemTableFac(),
      detailShow: false,
      currentItem: {},
      keyword: "",
    };
  },
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    calStat(stat) {
      if (stat === "现行") {
        return "c-green";
      } else if (stat === "已废止") {
        return "c-red";
      } else if (stat === "未实施") {
        return "c-blue";
      } else {
        return "c-no";
      }
    },
    calStatCertificate(c){
      if(c === '已认证'){
        return "success";
      }else if(c==="部分认证"){
        return "primary";
      }else{
        return "";
      }

    },
    onSearch() {
      this.itemTable = itemTableFac();
      this.onLoad();
    },
    onLoad() {
      this.itemTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.itemTable.Tpage,
          userToken: userToken,
          ask_data: "standardList",
          selected_list: [],
          keyword: this.keyword
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.itemTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.itemTable.Tpage.currentSize
          ) {
            this.itemTable.finished = true;
          }
          this.itemTable.loading = false;
          this.itemTable.Tpage.currentPage++;
        });
    },
    chooseItem(val) {
      this.currentItem = val;
      this.detailShow = true;
    },
    onClickBack() {
      this.detailShow = false;
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}

.cell-label {
  width: 180%;
  color: #666;
}
.detail-title {
  text-align: center;
  font-size: 0.8rem;
  padding: 0.5rem 0;
}
.c-green {
  color: rgb(33, 99, 33);
}

.c-red {
  color: rgb(173, 28, 28);
}

.c-blue {
  color: rgb(20, 59, 92);
}

.c-no {
  color: #999;
}

.c-tag{
  position: relative;
  bottom: 0.2rem;
  margin-right:0.1rem;
}
</style>